import { useEffect } from 'react';
import { updateModalContextInSentry } from './modalContext';
import { Task } from '../../gql/graphql';

interface UseModalContextOptions {
  isModalVisible: boolean;
  modalKey: string;
  task?: Task | null;
  step?: number;
}

/**
 * Hook to automatically sync modal context with Sentry
 * Usage: useModalContext({ isModalVisible, modalKey, task, step })
 */
export function useModalContext({ 
  isModalVisible, 
  modalKey, 
  task, 
  step 
}: UseModalContextOptions): void {
  useEffect(() => {
    if (isModalVisible && task) {
      updateModalContextInSentry(modalKey, { step, task });
    } else if (!isModalVisible) {
      updateModalContextInSentry(undefined);
    }
  }, [isModalVisible, modalKey, step, task?._id]);
}

